module.exports = __webpack_public_path__ + "static/media/calendar.38d1fee7.svg";